import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useMultiBuildingMobileViewInspectionEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.MultiBuildingMobileViewInspection,
    false
  );

  return Boolean(isEnabled);
}
